<div [class]="class" (click)="onClick()">
  <ng-content></ng-content>

  <ng-container *ngIf="name === current">
    <img width="20px" [src]="getSortIndicatorIcon()" />
  </ng-container>
</div>
